import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import {Box} from "@mui/system";
import {Loading} from "../../common";

/**
 * @param icon
 * @param options
 * @param handleSelection
 * @param anchorOrigin
 * @param transformOrigin
 * @returns {JSX.Element}
 * @constructor
 */
export default function BasicOptionsMenu({icon, options, handleSelection, anchorOrigin = {}, transformOrigin = {}  }) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    const performAction = (param) => {
        handleSelection(param);
        setAnchorEl(null);
    };

    const renderMenuItem = (item, index) => {
        return (
            <MenuItem
                key={index}
                sx={styles.menuItem}
                onClick={() => performAction(item)}
                disabled={item.disabled || item.isSelected}
            >
                <Box sx={styles.menuItemContainer}>
                    <Box sx={{mr: '15px'}}>{item.name}</Box>
                    {item.isSelected && <Loading height={15} size={15} />}
                </Box>
            </MenuItem>
        )
    }

    return (
        <Box sx={{}}>
            <IconButton
                aria-label="more"
                id="basic-button"
                aria-controls={open ? 'basic-options-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
                size={'small'}
            >
                {icon}
            </IconButton>
            <Menu
                id="basic-options-menu"
                MenuListProps={{
                    'aria-labelledby': 'basic-options-menu',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                PaperProps={{style: styles.menu}}
                anchorOrigin={anchorOrigin}
                transformOrigin={transformOrigin}
            >
                {options ? options.map((item, index) => renderMenuItem(item, index)) : <MenuItem />}
            </Menu>
        </Box>
    );
}

const styles = {
    menu: {
        border: "solid 1px #dee2e0",
        boxShadow: "0 2px 4px 0 rgba(196, 201, 199, 0.5)",
        padding: '0px',
        maxHeight: 48 * 4.5,
        width: '18ch',
    },
    menuItem: {
        paddingTop: '5px',
        paddingBottom: '5px',
        outline: 'none'
    },
    menuItemContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    }
}
